<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadSlogans(1, true)">

      <template slot="actions">
        <vx-input-group>
          <vs-input :placeholder="$t('slogan')" v-model="sloganFormData.name" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addSloganButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addSlogan">{{ $t('add_slogan') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('slogan')" v-model="sloganSearchParams.slogan" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="statusOptions" :reduce="label => label.value" :placeholder="$t('status')" v-model="sloganSearchParams.isActive" class="mb-4 md:mb-0" />
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadSlogans(1, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="sloganDataContainer" :title="$t('slogan')" class="mb-8 vs-con-loading__container">
      <shared-user-slogans-list
        :slogans="slogans"
        @customClickStatus="status"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-slogans-list>
      <template slot="footer">
        <paginate
          :total="slogansPages"
          :click-handler="loadSlogans"
          v-model="initialPage"
          goto
        />
      </template>
    </vx-card>
  </div>
</template>

<script>
import Slogan from '@/models/Slogan'
import SharedUserSlogansList from '@/views/Shared/Slogans/List'
import Paginate from '@/mixins/paginate'
import { statusOptions } from '@/config/options'

export default {
  name: 'User.Slogan',
  mixins: [Paginate],
  components: {
    SharedUserSlogansList
  },
  data () {
    return {
      slogansEdit: {},
      slogans: {},
      slogansPages: 1,
      sloganFormData: {
        name: '',
        is_active: '',
        id: ''
      },
      sloganFormErrors: {},
      sloganSearchParams: {
        slogan: typeof this.$route.query.slogan !== 'undefined' ? this.$route.query.slogan : '',
        isActive: typeof this.$route.query.isActive !== 'undefined' ? this.$route.query.isActive : ''
      },
      statusOptions
    }
  },
  mounted () {
    this.loadSlogans(this.initialPage)
  },
  methods: {
    async loadSlogans (page = 1, backToPageOne = false) {
      this.$vs.loading({container: '#sloganDataContainer'})

      const response = await Slogan.all({ ...this.sloganSearchParams, page })

      this.$router.replace({ query: { ...this.sloganSearchParams, page } })
      this.slogans = response.data.data.slogans
      this.slogansPages = response.data.meta.pagination.last_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }

      this.$vs.loading.close('#sloganDataContainer > .con-vs-loading')
    },
    async addSlogan (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addSloganButton', scale: 0.45})
      if (this.sloganFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_slogan_error_message'),
          confirmButton: this.$t('confirm')
        })

      } else if (!this.$store.getters.isFormInProgress) {
        this.$store.dispatch('setIsFormInProgress', true)
        await Slogan.save(this.sloganFormData)
        this.$store.dispatch('setIsFormInProgress', false)
        this.loadSlogans()
        this.sloganFormData = {
          name: '',
          is_active: '',
          id: ''
        }
        this.sloganFormErrors = {}
      }
      this.$vs.loading.close('#addSloganButton > .con-vs-loading')
    },
    async status (key) {
      try {
        if (this.slogans[key].is_active === 1) {
          this.slogans[key].is_active = 0
        } else {
          this.slogans[key].is_active = 1
        }
        await Slogan.update(this.slogans[key])
        this.slogans[key].sloganFormErrors = {}
      } catch (e) {
        this.slogans[key].sloganFormErrors = e.response.data.errors
      }
    },
    async edit (key) {
      this.slogans[key].edit = true
      const editElem = this.slogans[key]
      const editObj = {
        name: editElem.name
      }
      this.slogansEdit[key] = editObj
    },
    async cancel (key) {
      this.slogans[key].name = this.slogansEdit[key].name
      this.slogans[key].edit = false
      this.slogans[key].sloganFormErrors = {}
      delete this.slogansEdit[key]
    },
    async save (key, id) {
      try {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('slogan_update_confirmation_title'),
          text: this.$t('slogan_update_confirmation_text'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })
        if (confirm.value) {
          this.$vs.loading({background: 'primary', color: '#fff', container: `#updateSloganButton${id}`, scale: 0.45})
          await Slogan.update(this.slogans[key])
          this.slogans[key].edit = false
          this.slogans[key].sloganFormErrors = {}
          this.$vs.loading.close(`#updateSloganButton${id} > .con-vs-loading`)
        }
      } catch (e) {
        this.slogans[key].sloganFormErrors = e.response.data.errors
        this.$vs.loading.close(`#updateSloganButton${id} > .con-vs-loading`)
      }
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Slogan.delete(id)
        this.loadSlogans()
      }
    }
  }
}
</script>

<style lang="scss">
#addSloganButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
